import { render, staticRenderFns } from "./HomeServiceOperationRankingEmployeesNumber.vue?vue&type=template&id=86a2c27a&scoped=true&"
import script from "./HomeServiceOperationRankingEmployeesNumber.vue?vue&type=script&lang=js&"
export * from "./HomeServiceOperationRankingEmployeesNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a2c27a",
  null
  
)

export default component.exports